// in the V3 destionaton list, we have added a new field called 'isLlcFeatureRequired' to indicate whether the destination requires the LLC feature or not.
// in the V3 destioantion list,EDI always restrictedDepartures arryay ,becasue we don't have any flight from UK or IE to EDI ( Given list EDI not mentioned in any destination restrictedDepartures array)
// default_transfer - if true so default transfer selected to that destination, if false so default transfer not selected to that destination.
export const DestinationList: DestinationListType[] = [
  {
    "Searc ID": 10559,
    airport_code: "AUH",
    "Display Name #1": "Abu Dhabi, Middle East",
    default_transfer: false,
    transfer_add: false,
    isLlcFeatureRequired: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? true : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? true : false,
    },
    isTurkeyDestination: false,
    restrictedDepartures: ["LGW", "STN", "LTN", "LCY", "BHX", "NCL", "GLA", "EDI", "CWL", "BFS", "ORK", "SNN", "NOC", "BRS", "EMA", "LBA", "LPL"],
  },
  {
    "Searc ID": 10271,
    airport_code: "AGA",
    "Display Name #1": "Agadir, Morocco",
    default_transfer: false,
    transfer_add: true,
    isLlcFeatureRequired: true,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? false : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? false : false,
    },
    isTurkeyDestination: false,
    restrictedDepartures: ["LHR", "LCY", "CWL", "ORK", "SNN", "NOC", "EDI", "BRS", "EMA", "LBA", "LPL"],
  },
  {
    "Searc ID": 31376,
    airport_code: "DXB",
    "Display Name #1": "Ajman, Middle East",
    default_transfer: false,
    transfer_add: false,
    isLlcFeatureRequired: false,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? true : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? true : false,
    },
    restrictedDepartures: ["LTN", "LCY", "CWL", "BFS", "ORK", "SNN", "NOC", "BRS", "EMA", "LBA", "LPL"],
  },
  {
    "Searc ID": 10598,
    airport_code: "ANU",
    "Display Name #1": "Anguilla, Caribbean",
    default_transfer: false,
    transfer_add: true,
    isLlcFeatureRequired: false,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? true : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? true : false,
    },
    restrictedDepartures: ["STN", "LTN", "LCY", "MAN", "BHX", "NCL", "GLA", "EDI", "CWL", "BFS", "ORK", "SNN", "NOC", "BRS", "EMA", "LBA", "LPL"],
  },
  {
    "Searc ID": 10628,
    airport_code: "AYT",
    "Display Name #1": "Antalya, Turkey",
    default_transfer: false,
    transfer_add: true,
    isLlcFeatureRequired: false,
    isTurkeyDestination: true,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? false : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? false : false,
    },
    restrictedDepartures: ["LTN", "LCY", "CWL", "BFS", "SNN", "NOC"],
  },
  {
    "Searc ID": 10430,
    airport_code: "ANU",
    "Display Name #1": "Antigua, Caribbean",
    default_transfer: false,
    transfer_add: true,
    isLlcFeatureRequired: false,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? true : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? true : false,
    },
    restrictedDepartures: ["STN", "LTN", "LCY", "BHX", "NCL", "CWL", "BFS", "NOC", "BRS", "EMA", "LBA", "LPL"],
  },
  {
    "Searc ID": 10553,
    airport_code: "AUA",
    "Display Name #1": "Aruba, Caribbean",
    default_transfer: false,
    transfer_add: true,
    isLlcFeatureRequired: false,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? true : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? true : false,
    },
    restrictedDepartures: ["STN", "LTN", "LCY", "MAN", "BHX", "NCL", "GLA", "EDI", "CWL", "BFS", "ORK", 'SNN', "NOC", "BRS", "EMA", "LBA", "LPL"],
  },
  {
    "Searc ID": 31302,
    airport_code: "NAS",
    "Display Name #1": "Bahamas, Caribbean",
    default_transfer: false,
    transfer_add: true,
    isLlcFeatureRequired: false,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? true : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? true : false,
    },
    restrictedDepartures: ["LGW", "STN", "LTN", "LCY", "MAN", "BHX", "CWL", "NOC", "BRS", "EMA", "LBA", "LPL"],
  },
  {
    "Searc ID": 11884,
    airport_code: "DPS",
    "Display Name #1": "Bali, Indonesia",
    default_transfer: false,
    transfer_add: false,
    isLlcFeatureRequired: false,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? true : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? true : false,
    },
    restrictedDepartures: ["LTN", "LCY", "MAN", "EDI", "CWL", "ORK", 'SNN', "NOC", "BRS", "EMA", "LBA", "LPL"],
  },
  // {
  //   "Searc ID": 10877,
  //   airport_code: "BKK",
  //   "Display Name #1": "Bangkok, Thailand",
  //   default_transfer: false,
  //   transfer_add: false,
  //   isLlcFeatureRequired: false,
  //   discountPrice: {
  //     isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? true : false,
  //     isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? true : false,
  //   },
  //   restrictedDepartures: ["LTN", "LCY", "MAN", "EDI", "CWL", "ORK", 'SNN', "NOC"],
  // },
  {
    "Searc ID": 10785,
    airport_code: "BGI",
    "Display Name #1": "Barbados, Caribbean",
    default_transfer: false,
    transfer_add: true,
    isLlcFeatureRequired: false,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? true : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? true : false,
    },
    restrictedDepartures: ["LGW", "STN", "LTN", "LCY", "BHX", "CWL", "BFS", "NOC", "BRS", "EMA", "LBA", "LPL"],
  },
  {
    "Searc ID": 10714,
    airport_code: "BDA",
    "Display Name #1": "Bermuda, Caribbean",
    default_transfer: false,
    transfer_add: false,
    isLlcFeatureRequired: false,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? true : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? true : false,
    },
    restrictedDepartures: ["LGW", "STN", "LTN", "LCY", "MAN", "BHX", "CWL", "NOC", "BRS", "EMA", "LBA", "LPL"],
  },
  {
    "Searc ID": 11166,
    airport_code: "BJV",
    "Display Name #1": "Bodrum, Turkey",
    default_transfer: false,
    transfer_add: true,
    isLlcFeatureRequired: false,
    isTurkeyDestination: true,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? false : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? false : false,
    },
    restrictedDepartures: ["STN", "LTN", "LCY", "NCL", "GLA", "CWL", "BFS", "ORK", "SNN", "NOC", "BRS", "EMA", "LBA", "LPL"],
  },
  // {
  //   "Searc ID": 10875,
  //   airport_code: "BKI",
  //   "Display Name #1": "Borneo, Malaysia",
  //   default_transfer: false,
  //   transfer_add: false,
  //   isLlcFeatureRequired: false,
  //   discountPrice: {
  //     isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? true : false,
  //     isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? true : false,
  //   },
  //   restrictedDepartures: ["LTN", "LCY", "MAN", "EDI", "CWL", "NOC", "ORK", 'SNN', "NOC"],
  // },
  {
    "Searc ID": 11623,
    airport_code: "CUN",
    "Display Name #1": "Cancun & Caribbean Coast, Mexico",
    default_transfer: false,
    transfer_add: false,
    isLlcFeatureRequired: false,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? true : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? true : false,
    },
    restrictedDepartures: ["LHR", "STN", "LTN", "LCY", "MAN", "BHX", "NCL", "GLA", "EDI", "CWL", "BFS", "NOC", "ORK", 'SNN', "NOC", "BRS", "EMA", "LBA", "LPL"],
  },
  // {
  //   "Searc ID": 11537,
  //   airport_code: "CPT",
  //   "Display Name #1": "Cape Town, South Africa",
  //   default_transfer: false,
  //   transfer_add: false,
  //   isLlcFeatureRequired: false,
  //   discountPrice: {
  //     isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? true : false,
  //     isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? true : false,
  //   },
  //   restrictedDepartures: ["LTN", "LCY", "MAN", "EDI", "CWL", "BFS", "NOC", "ORK", 'SNN', "NOC"],
  // },
  {
    "Searc ID": 12422,
    airport_code: "GCM",
    "Display Name #1": "Cayman Islands, Caribbean",
    default_transfer: false,
    transfer_add: false,
    isLlcFeatureRequired: false,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? true : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? true : false,
    },
    restrictedDepartures: ["LGW", "STN", "LTN", "LCY", "MAN", "BHX", "CWL", "NOC", "BRS", "EMA", "LBA", "LPL"],
  },
  {
    "Searc ID": 11498,
    airport_code: "CNX",
    "Display Name #1": "Chiang Mai, Thailand",
    default_transfer: false,
    transfer_add: false,
    isLlcFeatureRequired: false,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? true : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? true : false,
    },
    restrictedDepartures: ["LTN", "LCY", "MAN", "EDI", "CWL", "ORK", 'SNN', "NOC", "BRS", "EMA", "LBA", "LPL"],
  },
  {
    "Searc ID": 32612,
    airport_code: "CFU",
    "Display Name #1": "Corfu, Greece",
    default_transfer: false,
    transfer_add: false,
    isLlcFeatureRequired: true,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? false : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? false : false,
    },
    restrictedDepartures: ["LCY", "CWL", "ORK", "NOC", "EDI", "BRS", "EMA", "LBA", "LPL"],
  },
  {
    "Searc ID": 32613,
    airport_code: "HER",
    "Display Name #1": "Crete, Greece",
    default_transfer: false,
    transfer_add: false,
    isLlcFeatureRequired: true,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? false : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? false : false,
    },
    restrictedDepartures: ["LCY", "CWL", "ORK", "SNN", "NOC", "EDI", "BRS", "EMA", "LBA", "LPL"],
  },
  // {
  //   "Searc ID": 11712,
  //   airport_code: "DAD",
  //   "Display Name #1": "Da Nang, Vietnam",
  //   default_transfer: false,
  //   transfer_add: false,
  //   isLlcFeatureRequired: false,
  //   discountPrice: {
  //     isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? true : false,
  //     isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? true : false,
  //   },
  //   restrictedDepartures: ["LTN", "LCY", "MAN", "EDI", "CWL", "ORK", 'SNN', "NOC"],
  // },
  {
    "Searc ID": 11828,
    airport_code: "DLM",
    "Display Name #1": "Dalaman, Turkey",
    default_transfer: false,
    transfer_add: true,
    isLlcFeatureRequired: false,
    isTurkeyDestination: true,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? false : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? false : false,
    },
    restrictedDepartures: ["LTN", "LCY", "CWL", "BFS", "ORK", "SNN", "NOC", "BRS", "EMA", "LBA", "LPL"],
  },
  {
    "Searc ID": 15805,
    airport_code: "PUJ",
    "Display Name #1": "Dominican Republic, Caribbean",
    default_transfer: false,
    transfer_add: false,
    isLlcFeatureRequired: false,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? true : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? true : false,
    },
    restrictedDepartures: ["LHR", "STN", "LTN", "LCY", "MAN", "BHX", "NCL", "GLA", "BFS", "EDI", "CWL", "ORK", 'SNN', "NOC", "BRS", "EMA", "LBA", "LPL"],
  },
  {
    "Searc ID": 11945,
    airport_code: "DXB",
    "Display Name #1": "Dubai, Middle East",
    default_transfer: false,
    transfer_add: false,
    isLlcFeatureRequired: false,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? true : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? true : false,
    },
    restrictedDepartures: ["LTN", "LCY", "CWL", "BFS", "ORK", 'SNN', "NOC", "BRS", "EMA", "LBA", "LPL"],
  },
  {
    "Searc ID": 11739,
    airport_code: "DBV",
    "Display Name #1": "Dubrovnik, Croatia",
    default_transfer: false,
    transfer_add: true,
    isLlcFeatureRequired: true,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? false : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? false : false,
    },
    restrictedDepartures: ["LHR", "LTN", "LCY", "CWL", "ORK", 'SNN', "NOC", "EDI", "BRS", "EMA", "LBA", "LPL"],
  },
  // {
  //   "Searc ID": 17425,
  //   airport_code: "KUL",
  //   "Display Name #1": "East Coast and Kuantan, Malaysia",
  //   default_transfer: false,
  //   transfer_add: false,
  //   isLlcFeatureRequired: false,
  //   discountPrice: {
  //     isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? true : false,
  //     isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? true : false,
  //   },
  //   restrictedDepartures: ["STN", "LTN", "LCY", "CWL", "BFS", "ORK", 'SNN', "NOC"],
  // },
  {
    "Searc ID": 12196,
    airport_code: "FAO",
    "Display Name #1": "Faro, Portugal",
    default_transfer: false,
    transfer_add: true,
    isLlcFeatureRequired: true,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? false : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? false : false,
    },
    restrictedDepartures: ["ORK", "EDI", "BRS", "EMA", "LBA", "LPL"],
  },
  {
    "Searc ID": 12270,
    airport_code: "FLR",
    "Display Name #1": "Florence, Italy",
    default_transfer: false,
    transfer_add: false,
    isLlcFeatureRequired: true,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? false : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? false : false,
    },
    restrictedDepartures: ["STN", "LTN", "MAN", "BHX", "NCL", "GLA", "CWL", "BFS", "DUB", "ORK", "SNN", "NOC", "EDI", "BRS", "EMA", "LBA", "LPL"],
  },
  {
    "Searc ID": 12354,
    airport_code: "FUE",
    "Display Name #1": "Fuerteventura, Canary Islands",
    default_transfer: false,
    transfer_add: true,
    isLlcFeatureRequired: true,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? false : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? false : false,
    },
    restrictedDepartures: ["LHR", "LCY", "GLA", "CWL", "NOC", "EDI", "BRS", "EMA", "LBA", "LPL"],
  },
  {
    "Searc ID": 31535,
    airport_code: "DXB",
    "Display Name #1": "Fujairah, Middle East",
    default_transfer: false,
    transfer_add: false,
    isLlcFeatureRequired: false,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? true : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? true : false,
    },
    restrictedDepartures: ["LTN", "LCY", "CWL", "BFS", "ORK", 'SNN', "NOC", "BRS", "EMA", "LBA", "LPL"],
  },
  {
    "Searc ID": 12286,
    airport_code: "FNC",
    "Display Name #1": "Funchal, Portugal",
    default_transfer: false,
    transfer_add: true,
    isLlcFeatureRequired: true,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? false : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? false : false,
    },
    restrictedDepartures: ["BRS", "EMA", "LBA", "LPL"],
  },
  {
    "Searc ID": 14104,
    airport_code: "LPA",
    "Display Name #1": "Gran Canaria, Canary Islands",
    default_transfer: false,
    transfer_add: true,
    isLlcFeatureRequired: true,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? false : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? false : false,
    },
    restrictedDepartures: ["LHR", "LCY", "GLA", "CWL", "NOC", "EDI", "BRS", "EMA", "LBA", "LPL"],
  },
  {
    "Searc ID": 12549,
    airport_code: "GND",
    "Display Name #1": "Grenada, Caribbean",
    default_transfer: false,
    transfer_add: true,
    isLlcFeatureRequired: false,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? true : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? true : false,
    },
    restrictedDepartures: ["STN", "LTN", "LCY", "MAN", "BHX", "NCL", "GLA", "EDI", "CWL", "BFS", "ORK", 'SNN', "NOC", "BRS", "EMA", "LBA", "LPL"],
  },
  {
    "Searc ID": 31350,
    airport_code: "SVD",
    "Display Name #1": "Grenadines, Caribbean",
    default_transfer: false,
    transfer_add: false,
    isLlcFeatureRequired: false,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? true : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? true : false,
    },
    restrictedDepartures: ["BRS", "EMA", "LBA", "LPL"],
  },
  {
    "Searc ID": 32614,
    airport_code: "SKG",
    "Display Name #1": "Halkidiki, Greece",
    default_transfer: false,
    transfer_add: true,
    isLlcFeatureRequired: true,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? false : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? false : false,
    },
    restrictedDepartures: ["LTN", "LCY", "CWL", "BFS", "ORK", "SNN", "NOC", "EDI", "BRS", "EMA", "LBA", "LPL"],
  },
  // {
  //   "Searc ID": 31296,
  //   airport_code: "DAD",
  //   "Display Name #1": "Hoi An, Vietnam",
  //   default_transfer: false,
  //   transfer_add: false,
  //   isLlcFeatureRequired: false,
  //   discountPrice: {
  //     isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? true : false,
  //     isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? true : false,
  //   },
  //   restrictedDepartures: ["STN", "LTN", "LCY", "BHX", "NCL", "CWL", "BFS", "ORK", 'SNN', "NOC"],
  // },
  {
    "Searc ID": 12808,
    airport_code: "HKG",
    "Display Name #1": "Hong Kong, Asia",
    default_transfer: false,
    transfer_add: false,
    isLlcFeatureRequired: false,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? true : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? true : false,
    },
    restrictedDepartures: ["LTN", "LCY", "EDI", "CWL", "ORK", 'SNN', "NOC", "BRS", "EMA", "LBA", "LPL"],
  },
  {
    "Searc ID": 12785,
    airport_code: "BKK",
    "Display Name #1": "Hua Hin and Cha Am, Thailand",
    default_transfer: false,
    transfer_add: false,
    isLlcFeatureRequired: false,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? true : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? true : false,
    },
    restrictedDepartures: ["LTN", "LCY", "MAN", "EDI", "CWL", "NOC", "BRS", "EMA", "LBA", "LPL"],
  },
  {
    "Searc ID": 12987,
    airport_code: "IBZ",
    "Display Name #1": "Ibiza, Spain",
    default_transfer: false,
    transfer_add: true,
    isLlcFeatureRequired: true,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? false : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? false : false,
    },
    restrictedDepartures: ["GLA", "CWL", "ORK", "SNN", "NOC", "EDI", "BRS", "EMA", "LBA", "LPL"],
  },
  {
    "Searc ID": 13205,
    airport_code: "ADB",
    "Display Name #1": "Izmir, Turkey",
    default_transfer: false,
    transfer_add: true,
    isLlcFeatureRequired: false,
    isTurkeyDestination: true,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? false : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? false : false,
    },
    restrictedDepartures: ["LHR", "LTN", "LCY", "CWL", "BFS", "SNN", "NOC", "EMA", "LBA"],
  },
  {
    "Searc ID": 31636,
    airport_code: "MBJ",
    "Display Name #1": "Jamaica, Caribbean",
    default_transfer: false,
    transfer_add: false,
    isLlcFeatureRequired: false,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? true : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? true : false,
    },
    restrictedDepartures: ["LGW", "STN", "LTN", "LCY", "MAN", "BHX", "NCL", "CWL", "BFS", "NOC", "BRS", "EMA", "LBA", "LPL"],
  },
  // {
  //   "Searc ID": 13298,
  //   airport_code: "JNB",
  //   "Display Name #1": "Johannesburg, South Africa",
  //   default_transfer: false,
  //   transfer_add: false,
  //   isLlcFeatureRequired: false,
  //   discountPrice: {
  //     isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? true : false,
  //     isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? true : false,
  //   },
  //   restrictedDepartures: ["LTN", "LCY", "EDI", "CWL", "ORK", 'SNN', "NOC"],
  // },
  {
    "Searc ID": 31358,
    airport_code: "USM",
    "Display Name #1": "Khanom, Thailand",
    default_transfer: false,
    transfer_add: false,
    isLlcFeatureRequired: false,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? true : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? true : false,
    },
    restrictedDepartures: ["LTN", "LCY", "MAN", "EDI", "CWL", "ORK", "SNN", "NOC", "BRS", "EMA", "LBA", "LPL"],
  },
  {
    "Searc ID": 31293,
    airport_code: "HKT",
    "Display Name #1": "Khao Lak, Thailand",
    default_transfer: false,
    transfer_add: false,
    isLlcFeatureRequired: false,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? true : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? true : false,
    },
    restrictedDepartures: ["LTN", "LCY", "MAN", "EDI", "CWL", "NOC", "BRS", "EMA", "LBA", "LPL"],
  },
  {
    "Searc ID": 31294,
    airport_code: "KBV",
    "Display Name #1": "Koh Lanta, Thailand",
    default_transfer: false,
    transfer_add: false,
    isLlcFeatureRequired: false,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? true : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? true : false,
    },
    restrictedDepartures: ["LTN", "LCY", "MAN", "EDI", "CWL", "NOC", "BRS", "EMA", "LBA", "LPL"],
  },
  {
    "Searc ID": 31443,
    airport_code: "usm",
    "Display Name #1": "Koh Phangan, Thailand",
    default_transfer: false,
    transfer_add: false,
    isLlcFeatureRequired: false,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? true : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? true : false,
    },
    restrictedDepartures: ["LTN", "LCY", "MAN", "EDI", "CWL", "NOC", "BRS", "EMA", "LBA", "LPL"],
  },
  {
    "Searc ID": 17902,
    airport_code: "USM",
    "Display Name #1": "Koh Samui, Thailand",
    default_transfer: false,
    transfer_add: false,
    isLlcFeatureRequired: false,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? true : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? true : false,
    },
    restrictedDepartures: ["LTN", "LCY", "MAN", "EDI", "CWL", "ORK", "SNN", "NOC", "BRS", "EMA", "LBA", "LPL"],
  },
  {
    "Searc ID": 31445,
    airport_code: "HKT",
    "Display Name #1": "Koh Yao, Thailand",
    default_transfer: false,
    transfer_add: false,
    isLlcFeatureRequired: false,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? true : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? true : false,
    },
    restrictedDepartures: ["LTN", "LCY", "MAN", "EDI", "CWL", "NOC", "BRS", "EMA", "LBA", "LPL"],
  },
  {
    "Searc ID": 13484,
    airport_code: "KGS",
    "Display Name #1": "Kos, Greece",
    default_transfer: false,
    transfer_add: true,
    isLlcFeatureRequired: true,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? false : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? false : false,
    },
    restrictedDepartures: ["LHR", "LCY", "CWL", "BFS", "ORK", "SNN", "NOC", "EDI", "BRS", "EMA", "LBA", "LPL"],
  },
  {
    "Searc ID": 13405,
    airport_code: "KBV",
    "Display Name #1": "Krabi, Thailand",
    default_transfer: false,
    transfer_add: false,
    isLlcFeatureRequired: false,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? true : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? true : false,
    },
    restrictedDepartures: ["LTN", "LCY", "MAN", "EDI", "CWL", "NOC", "BRS", "EMA", "LBA", "LPL"],
  },
  // {
  //   "Searc ID": 13769,
  //   airport_code: "KUL",
  //   "Display Name #1": "Kuala Lumpur, Malaysia",
  //   default_transfer: false,
  //   transfer_add: false,
  //   isLlcFeatureRequired: false,
  //   discountPrice: {
  //     isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? true : false,
  //     isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? true : false,
  //   },
  //   restrictedDepartures: ["LTN", "LCY", "MAN", "EDI", "CWL", "ORK", "SNN", "NOC"],
  // },
  // {
  //   "Searc ID": 13961,
  //   airport_code: "LGK",
  //   "Display Name #1": "Langkawi, Malaysia",
  //   default_transfer: false,
  //   transfer_add: false,
  //   isLlcFeatureRequired: false,
  //   discountPrice: {
  //     isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? true : false,
  //     isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? true : false,
  //   },
  //   restrictedDepartures: ["LTN", "LCY", "MAN", "EDI", "CWL", "ORK", "SNN", "NOC"],
  // },
  {
    "Searc ID": 10218,
    airport_code: "ACE",
    "Display Name #1": "Lanzarote,Canary Islands",
    default_transfer: false,
    transfer_add: true,
    isLlcFeatureRequired: true,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? false : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? false : false,
    },
    restrictedDepartures: ["LHR", "LCY", "GLA", "CWL", "ORK", "EDI", "BRS", "EMA", "LBA", "LPL"],
  },
  {
    "Searc ID": 13894,
    airport_code: "LCA",
    "Display Name #1": "Larnaca, Cyprus",
    default_transfer: false,
    transfer_add: true,
    isLlcFeatureRequired: true,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? false : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? false : false,
    },
    restrictedDepartures: ["LCY", "CWL", "DUB", "ORK", "SNN", "NOC", "EDI", "BRS", "EMA", "LBA", "LPL"],
  },
  {
    "Searc ID": 10284,
    airport_code: "AGP",
    "Display Name #1": "Malaga - Costa Del Sol,Spain",
    default_transfer: false,
    transfer_add: true,
    isLlcFeatureRequired: true,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? false : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? false : false,
    },
    restrictedDepartures: ["LCY", "ORK", "EDI", "BRS", "EMA", "LBA", "LPL"],
  },
  {
    "Searc ID": 19381,
    airport_code: "MLE",
    "Display Name #1": "Maldives, Indian Ocean",
    default_transfer: true,
    transfer_add: false,
    isLlcFeatureRequired: false,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? true : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? true : false,
    },
    restrictedDepartures: ["LTN", "LCY", "CWL", "NOC", "BRS", "EMA", "LBA", "LPL"],
  },
  {
    "Searc ID": 14516,
    airport_code: "MLA",
    "Display Name #1": "Malta, Malta",
    default_transfer: false,
    transfer_add: true,
    isLlcFeatureRequired: true,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? false : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? false : false,
    },
    restrictedDepartures: ["LHR", "LCY", "CWL", "ORK", "NOC", "EDI", "BRS", "EMA", "LBA", "LPL"],
  },
  {
    "Searc ID": 16429,
    airport_code: "RAK",
    "Display Name #1": "Marrakech, Morocco",
    default_transfer: false,
    transfer_add: true,
    isLlcFeatureRequired: true,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? false : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? false : false,
    },
    restrictedDepartures: ["LHR", "LCY", "CWL", "ORK", "SNN", "NOC", "EDI", "BRS", "EMA", "LBA", "LPL"],
  },
  {
    "Searc ID": 14672,
    airport_code: "MRU",
    "Display Name #1": "Mauritius, Indian Ocean",
    default_transfer: false,
    transfer_add: false,
    isLlcFeatureRequired: false,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? true : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? true : false,
    },
    restrictedDepartures: ["LTN", "LCY", "CWL", "BFS", "ORK", "SNN", "NOC", "BRS", "EMA", "LBA", "LPL"],
  },
  {
    "Searc ID": 14267,
    airport_code: "MAH",
    "Display Name #1": "Menorca, Spain",
    default_transfer: false,
    transfer_add: true,
    isLlcFeatureRequired: true,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? false : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? false : false,
    },
    restrictedDepartures: ["LHR", "LCY", "BHX", "NCL", "GLA", "CWL", "ORK", "SNN", "NOC", "EDI", "BRS", "EMA", "LBA", "LPL"],
  },
  {
    "Searc ID": 14456,
    airport_code: "MXP",
    "Display Name #1": "Milan, Italy",
    default_transfer: false,
    transfer_add: false,
    isLlcFeatureRequired: true,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? false : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? false : false,
    },
    restrictedDepartures: ["LCY", "BHX", "NCL", "GLA", "CWL", "BFS", "ORK", "SNN", "NOC", "EDI", "BRS", "EMA", "LBA", "LPL"],
  },
  {
    "Searc ID": 14286,
    airport_code: "MBA",
    "Display Name #1": "Mombasa, Kenya",
    default_transfer: false,
    transfer_add: false,
    isLlcFeatureRequired: false,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? true : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? true : false,
    },
    restrictedDepartures: ["LTN", "LCY", "MAN", "EDI", "CWL", "ORK", "SNN", "NOC", "BRS", "EMA", "LBA", "LPL"],
  },
  {
    "Searc ID": 13294,
    airport_code: "JMK",
    "Display Name #1": "Mykonos, Greece",
    default_transfer: false,
    transfer_add: false,
    isLlcFeatureRequired: true,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? false : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? false : false,
    },
    restrictedDepartures: ["STN", "LTN", "LCY", "MAN", "NCL", "GLA", "CWL", "BFS", "DUB", "ORK", "SNN", "NOC", "EDI", "BRS", "EMA", "LBA", "LPL"],
  },
  // {
  //   "Searc ID": 15309,
  //   airport_code: "MCO",
  //   "Display Name #1": "Orlando",
  //   transfer_add: false,
  // isLlcFeatureRequired: false,  
  // discountPrice :{
  //     isDiscountUK:process.env.REACT_APP_PROJECT_COUNTRY === "uk" ?false:false,
  //     isDiscountIE:process.env.REACT_APP_PROJECT_COUNTRY === "ie" ?false:false,
  //   }
  // },
  {
    "Searc ID": 14879,
    airport_code: "NAP",
    "Display Name #1": "Naples, Italy",
    default_transfer: false,
    transfer_add: false,
    isLlcFeatureRequired: true,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? false : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? false : false,
    },
    restrictedDepartures: ["LCY", "NCL", "CWL", "BFS", "ORK", "NOC", "EDI", "BRS", "EMA", "LBA", "LPL"],
  },
  // {
  //   "Searc ID": 30202,
  //   airport_code: "CXR",
  //   "Display Name #1": "Nha Trang, Vietnam",
  //   default_transfer: false,
  //   transfer_add: false,
  //   isLlcFeatureRequired: false,
  //   discountPrice: {
  //     isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? true : false,
  //     isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? true : false,
  //   },
  //   restrictedDepartures: ["LON", "LGW", "LHR", "STN", "LTN", "LCY", "MAN", "BHX", "NCL", "GLA", "EDI", "CWL", "BFS", "DUB", "ORK", "SNN", "NOC"],
  // },
  {
    "Searc ID": 14327,
    airport_code: "MCT",
    "Display Name #1": "Oman, Middle East",
    default_transfer: false,
    transfer_add: true,
    isLlcFeatureRequired: false,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? true : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? true : false,
    },
    restrictedDepartures: ["LGW", "STN", "LTN", "LCY", "CWL", "BFS", "ORK", "SNN", "NOC", "BRS", "EMA", "LBA", "LPL"],
  },
  {
    "Searc ID": 15634,
    airport_code: "PMI",
    "Display Name #1": "Palma Mallorca, Spain",
    default_transfer: false,
    transfer_add: true,
    isLlcFeatureRequired: true,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? false : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? false : false,
    },
    restrictedDepartures: ["GLA", "CWL", "ORK", "EDI", "BRS", "EMA", "LBA", "LPL"],
  },
  // {
  //   "Searc ID": 32681,
  //   airport_code: "KUL",
  //   "Display Name #1": "Pangkor, Malaysia",
  //   default_transfer: false,
  //   transfer_add: false,
  //   isLlcFeatureRequired: false,
  //   discountPrice: {
  //     isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? true : false,
  //     isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? true : false,
  //   },
  //   restrictedDepartures: ["LON", "LGW", "LHR", "STN", "LTN", "LCY", "MAN", "BHX", "NCL", "GLA", "EDI", "CWL", "BFS", "DUB", "ORK", "SNN", "NOC"],
  // },
  {
    "Searc ID": 15508,
    airport_code: "PFO",
    "Display Name #1": "Paphos, Cyprus",
    default_transfer: false,
    transfer_add: true,
    isLlcFeatureRequired: true,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? false : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? false : false,
    },
    restrictedDepartures: ["LCY", "CWL", "ORK", "SNN", "NOC", "EDI", "BRS", "EMA", "LBA", "LPL"],
  },
  // {
  //   "Searc ID": 31478,
  //   airport_code: "SGN",
  //   "Display Name #1": "Phan Thiet, Vietnam",
  //   default_transfer: false,
  //   transfer_add: false,
  //   isLlcFeatureRequired: false,
  //   discountPrice: {
  //     isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? true : false,
  //     isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? true : false,
  //   },
  //   restrictedDepartures: ["LON", "LGW", "LHR", "STN", "LTN", "LCY", "MAN", "BHX", "NCL", "GLA", "EDI", "CWL", "BFS", "DUB", "ORK", "SNN", "NOC"],
  // },
  {
    "Searc ID": 15550,
    airport_code: "HKT",
    "Display Name #1": "Phi Phi Islands, Thailand",
    default_transfer: false,
    transfer_add: false,
    isLlcFeatureRequired: false,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? true : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? true : false,
    },
    restrictedDepartures: ["LTN", "LCY", "MAN", "EDI", "CWL", "NOC", "BRS", "EMA", "LBA", "LPL"],
  },
  {
    "Searc ID": 19391,
    airport_code: "HKT",
    "Display Name #1": "Phuket, Thailand",
    default_transfer: false,
    transfer_add: false,
    isLlcFeatureRequired: false,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? true : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? true : false,
    },
    restrictedDepartures: ["LTN", "LCY", "MAN", "EDI", "CWL", "ORK", "SNN", "NOC", "BRS", "EMA", "LBA", "LPL"],
  },
  {
    "Searc ID": 15820,
    airport_code: "PUY",
    "Display Name #1": "Pula, Croatia",
    default_transfer: false,
    transfer_add: true,
    isLlcFeatureRequired: true,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? false : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? false : false,
    },
    restrictedDepartures: ["LCY", "NCL", "CWL", "BFS", "DUB", "ORK", "SNN", "NOC", "EDI", "BRS", "EMA", "LBA", "LPL"],
  },
  {
    "Searc ID": 11866,
    airport_code: "DOH",
    "Display Name #1": "Qatar, Middle East",
    default_transfer: false,
    transfer_add: false,
    isLlcFeatureRequired: false,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? true : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? true : false,
    },
    restrictedDepartures: ["STN", "LTN", "LCY", "NCL", "GLA", "CWL", "BFS", "ORK", "SNN", "NOC", "BRS", "EMA", "LBA", "LPL"],
  },
  {
    "Searc ID": 16567,
    airport_code: "DXB",
    "Display Name #1": "Ras Al Khaimah, Middle East",
    default_transfer: false,
    transfer_add: false,
    isLlcFeatureRequired: false,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? true : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? true : false,
    },
    restrictedDepartures: ["LTN", "LCY", "CWL", "BFS", "ORK", "SNN", "NOC", "BRS", "EMA", "LBA", "LPL"],
  },
  {
    "Searc ID": 31356,
    airport_code: "RUN",
    "Display Name #1": "Reunion, Indian Ocean",
    default_transfer: false,
    transfer_add: true,
    isLlcFeatureRequired: false,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? true : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? true : false,
    },
    restrictedDepartures: ["STN", "LTN", "LCY", "NCL", "GLA", "EDI", "CWL", "BFS", "ORK", "SNN", "NOC", "BRS", "EMA", "LBA", "LPL"],
  },
  {
    "Searc ID": 16534,
    airport_code: "RHO",
    "Display Name #1": "Rhodes, Greece",
    default_transfer: false,
    transfer_add: true,
    isLlcFeatureRequired: true,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? false : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? false : false,
    },
    restrictedDepartures: ["LCY", "CWL", "SNN", "NOC", "EDI", "BRS", "EMA", "LBA", "LPL"],
  },
  {
    "Searc ID": 16607,
    airport_code: "FCO",
    "Display Name #1": "Rome, Italy",
    default_transfer: false,
    transfer_add: false,
    isLlcFeatureRequired: true,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? false : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? false : false,
    },
    restrictedDepartures: ["LCY", "CWL", "BFS", "ORK", "SNN", "NOC", "EDI", "BRS", "EMA", "LBA", "LPL"],
  },
  {
    "Searc ID": 32620,
    airport_code: "JTR",
    "Display Name #1": "Santorini, Greece",
    default_transfer: false,
    transfer_add: true,
    isLlcFeatureRequired: true,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? false : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? false : false,
    },
    restrictedDepartures: ["LCY", "CWL", "BFS", "ORK", "SNN", "NOC", "EDI", "BRS", "EMA", "LBA", "LPL"],
  },
  // {
  //   "Searc ID": 31542,
  //   airport_code: "SEZ",
  //   "Display Name #1": "Seychelles, Indian Ocean",
  //   default_transfer: false,
  //   transfer_add: true,
  //   isLlcFeatureRequired: false,
  //   discountPrice: {
  //     isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? true : false,
  //     isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? true : false,
  //   },
  //   restrictedDepartures: ["LTN", "LCY", "CWL", "BFS", "ORK", "SNN", "NOC"],
  // },
  {
    "Searc ID": 16907,
    airport_code: "SIN",
    "Display Name #1": "Singapore, Asia",
    default_transfer: false,
    transfer_add: false,
    isLlcFeatureRequired: false,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? true : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? true : false,
    },
    restrictedDepartures: ["LTN", "LCY", "MAN", "EDI", "CWL", "ORK", "SNN", "NOC", "BRS", "EMA", "LBA", "LPL"],
  },
  {
    "Searc ID": 17080,
    airport_code: "SPU",
    "Display Name #1": "Split, Croatia",
    default_transfer: false,
    transfer_add: true,
    isLlcFeatureRequired: true,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? false : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? false : false,
    },
    restrictedDepartures: ["NCL", "GLA", "CWL", "BFS", "ORK", "SNN", "NOC", "EDI", "BRS", "EMA", "LBA", "LPL"],
  },
  {
    "Searc ID": 31543,
    airport_code: "CMB",
    "Display Name #1": "Sri Lanka, Indian Ocean",
    default_transfer: false,
    transfer_add: false,
    isLlcFeatureRequired: false,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? true : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? true : false,
    },
    restrictedDepartures: ["LTN", "LCY", "CWL", "ORK", "SNN", "NOC", "BRS", "EMA", "LBA", "LPL"],
  },
  {
    "Searc ID": 16943,
    airport_code: "SKB",
    "Display Name #1": "St Kitts and Nevis, Caribbean",
    default_transfer: false,
    transfer_add: true,
    isLlcFeatureRequired: false,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? true : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? true : false,
    },
    restrictedDepartures: ["LHR", "STN", "LTN", "LCY", "MAN", "BHX", "NCL", "GLA", "EDI", "CWL", "BFS", "ORK", "SNN", "NOC", "BRS", "EMA", "LBA", "LPL"],
  },
  {
    "Searc ID": 16984,
    airport_code: "UVF",
    "Display Name #1": "St Lucia, Caribbean",
    default_transfer: false,
    transfer_add: true,
    isLlcFeatureRequired: false,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? true : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? true : false,
    },
    restrictedDepartures: ["LHR", "STN", "LTN", "LCY", "MAN", "BHX", "NCL", "GLA", "EDI", "CWL", "BFS", "ORK", "SNN", "NOC", "BRS", "EMA", "LBA", "LPL"],
  },
  // {
  //   "Searc ID": 15102,
  //   airport_code: "DUR",
  //   "Display Name #1": "Sun City, South Africa",
  //   default_transfer: false,
  //   transfer_add: false,
  //   isLlcFeatureRequired: false,
  //   discountPrice: {
  //     isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? true : false,
  //     isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? true : false,
  //   },
  //   restrictedDepartures: ["LGW", "STN", "LTN", "LCY", "MAN", "BHX", "CWL", "ORK", "SNN", "NOC"],
  // },
  {
    "Searc ID": 17368,
    airport_code: "TFS",
    "Display Name #1": "Tenerife, Canary Islands",
    default_transfer: false,
    transfer_add: true,
    isLlcFeatureRequired: true,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? false : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? false : false,
    },
    restrictedDepartures: ["LCY", "GLA", "ORK", "EDI", "BRS", "EMA", "LBA", "LPL"],
  },
  {
    "Searc ID": 17311,
    airport_code: "TAB",
    "Display Name #1": "Tobago, Caribbean",
    default_transfer: false,
    transfer_add: false,
    isLlcFeatureRequired: false,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? true : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? true : false,
    },
    restrictedDepartures: ["LHR", "STN", "LTN", "LCY", "MAN", "BHX", "NCL", "GLA", "EDI", "CWL", "BFS", "ORK", "SNN", "NOC", "BRS", "EMA", "LBA", "LPL"],
  },
  {
    "Searc ID": 17968,
    airport_code: "VCE",
    "Display Name #1": "Venice, Italy",
    default_transfer: false,
    transfer_add: false,
    isLlcFeatureRequired: true,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? false : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? false : false,
    },
    restrictedDepartures: ["LCY", "NCL", "GLA", "CWL", "BFS", "SNN", "NOC", "EDI", "BRS", "EMA", "LBA", "LPL"],
  },
  {
    "Searc ID": 18074,
    airport_code: "VRN",
    "Display Name #1": "Verona, Italy",
    default_transfer: false,
    transfer_add: false,
    isLlcFeatureRequired: true,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? false : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? false : false,
    },
    restrictedDepartures: ["LHR", "LCY", "CWL", "CWL", "ORK", "SNN", "NOC", "EDI", "BRS", "EMA", "LBA", "LPL"],
  },
  {
    "Searc ID": 19290,
    airport_code: "ZTH",
    "Display Name #1": "Zakinthos, Greece",
    default_transfer: false,
    transfer_add: false,
    isLlcFeatureRequired: true,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? false : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? false : false,
    },
    restrictedDepartures: ["LCY", "CWL", "ORK", "SNN", "NOC", "EDI", "BRS", "EMA", "LBA", "LPL"],
  },
  {
    "Searc ID": 19235,
    airport_code: "ZNZ",
    "Display Name #1": "Zanzibar, Africa",
    default_transfer: false,
    transfer_add: false,
    isLlcFeatureRequired: false,
    isTurkeyDestination: false,
    discountPrice: {
      isDiscountUK: process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? true : false,
      isDiscountIE: process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? true : false,
    },
    restrictedDepartures: ["LTN", "LCY", "MAN", "EDI", "CWL", "ORK", "SNN", "NOC", "BRS", "EMA", "LBA", "LPL"],
  },
  // {
  //   "Searc ID": 10271,
  //   airport_code: "AGA",
  //   "Display Name #1": "Agadir, Morocco",
  // default_transfer: false,  
  // transfer_add: true,
  // isLlcFeatureRequired: true,  
  // discountPrice :{
  //     isDiscountUK:process.env.REACT_APP_PROJECT_COUNTRY === "uk" ?true:false,
  //     isDiscountIE:process.env.REACT_APP_PROJECT_COUNTRY === "ie" ?true:false,
  //   }
  // },

  // {
  //   "Searc ID": 15309,
  //   airport_code: "MCO",
  //   "Display Name #1": "Orlando",
  // default_transfer: false,  
  // transfer_add: false,
  // isLlcFeatureRequired: true,  
  // discountPrice :{
  //     isDiscountUK:process.env.REACT_APP_PROJECT_COUNTRY === "uk" ?false:false,
  //     isDiscountIE:process.env.REACT_APP_PROJECT_COUNTRY === "ie" ?false:false,
  //   }
  // },


  // {
  //   "Searc ID": 15508,
  //   airport_code: "PFO",
  //   "Display Name #1": "Pisa, Italy",
  // default_transfer: false,  
  // transfer_add: true,
  // isLlcFeatureRequired: true,  
  // discountPrice :{
  //     isDiscountUK:process.env.REACT_APP_PROJECT_COUNTRY === "uk" ?false:false,
  //     isDiscountIE:process.env.REACT_APP_PROJECT_COUNTRY === "ie" ?false:false,
  //   }
  // },


];
